import Header from './Header';

export { HeaderType } from './Header';
export default Header;
